/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackClassStudentViewModel } from "../types/FeedbackClassStudentViewModel.ts";

export const feedbackClassStudentViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  feedbackId: z.optional(z.number().int()),
  classStudentId: z.optional(z.number().int()),
  classStudentDescription: z.string().nullish(),
  classStudentCode: z.string().nullish(),
}) as unknown as ToZod<FeedbackClassStudentViewModel>;
